import { ForgeIcon, ForgeOption, ForgeSelect, ForgeTextField, ForgeTimePicker } from '@tylertech/forge-react';
import { FrequencyConfig, TimeInfo, TimezoneTypes } from 'common/types/frequencySelector/frequencySelector';
import React, { ChangeEvent, Dispatch, FC, SetStateAction } from 'react';
import { timezoneOptions } from '../constants/options';
import { I18n } from 'common/visualizations';

const scope = 'shared.components.frequency_selector.time';

export interface TimeDetailsProps {
  value: TimeInfo;
  setValue: Dispatch<SetStateAction<FrequencyConfig>>;
}

const TimeDetails: FC<TimeDetailsProps> = (props) => {
  const { value, setValue } = props;

  const onValueChange = <K extends keyof TimeInfo>(field: K, val: TimeInfo[K]) => {
    setValue((prevState) => ({
      ...prevState,
      timeInfo: {
        ...prevState.timeInfo,
        [field]: val
      }
    }));
  };

  return (
    <div className="picker-sub-container time" data-testid="frequency-selector-time">
      <p className="forge-typography--body2">{I18n.t('time_label', { scope })}</p>
      <ForgeTimePicker
        step={30}
        on-forge-time-picker-change={(event: CustomEvent) => onValueChange('time', event.detail)}
        value={value.time}
        allowInput={true}
        className="duration-time"
        data-testid="time-picker"
      >
        <ForgeTextField>
          <input type="text" id="time-picker" data-testid="time-picker-input-field" />
          <label htmlFor="time-picker">{I18n.t('time_field_placeholder', { scope })}</label>
        </ForgeTextField>
      </ForgeTimePicker>
      <ForgeSelect
        className="duration-time-zone"
        data-testid="timezone-select"
        value={value.timeZone}
        variant="plain"
        theme="primary"
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          onValueChange('timeZone', event.target.value as TimezoneTypes)
        }
        popoverIcon={false}
      >
        {timezoneOptions.map((option) => (
          <ForgeOption key={`timezone_${option.value}`} value={option.value}>
            {option.label}
          </ForgeOption>
        ))}
        <ForgeIcon slot="end" name="chevron_down" icon_type="button" theme="primary" />
      </ForgeSelect>
    </div>
  );
};

export default TimeDetails;
